import { createRouter, createWebHistory } from 'vue-router';
import Cookies from 'js-cookie';

function requireCookie(to, from, next) {
  const token = Cookies.get('access_token');
  if (token == null) {
    next({ name: 'Login' });
  } else {
    next();
  }
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/',
    name: 'Translate',
    component: () => import('@/views/TranslateView.vue'),
    beforeEnter: requireCookie,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
